import * as React from 'react';
import { ArchetypeSpecificStepRunSummaryPanelProps } from '.';

export const MetadataStepRunSummaryPanel: React.FC<ArchetypeSpecificStepRunSummaryPanelProps> = ({ stepRun }) => {
    return <div>Metadata Step Run Summary Panel - {stepRun.displayName || stepRun.stepId}</div>;
};
